const toggle = document.querySelector<HTMLButtonElement>('[data-nav-toggle]');
const nav = document.querySelector<HTMLElement>('[data-site-nav]');
const mqMobile = window.matchMedia('(max-width: 640px)'); // isMobile
const mqDesktop = window.matchMedia('(min-width: 641px)'); // isDesktop

const dropdownItems = (): NodeListOf<HTMLElement> =>
  document.querySelectorAll('[data-nav-dropdown]') as NodeListOf<HTMLElement>;

const getSubmenu = (item: HTMLElement | null): HTMLElement | null =>
  item ? item.querySelector<HTMLElement>('.site-nav__sub') : null;

const setCompanyExpanded = (item: HTMLElement | null, expanded: boolean): void => {
  const btn = item?.querySelector<HTMLButtonElement>('[data-company-menu]');
  if (btn) btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
};

const resetDropdownItem = (item: HTMLElement | null): void => {
  if (!item) return;
  item.classList.remove('is-open', 'is-active');
  const sub = getSubmenu(item);
  if (sub) sub.hidden = true;
  setCompanyExpanded(item, false);
};

const closeSubmenus = (): void => dropdownItems().forEach(resetDropdownItem);

const closeOtherDropdowns = (except: HTMLElement | null): void => {
  dropdownItems().forEach((item) => {
    if (item !== except) resetDropdownItem(item);
  });
};

if (toggle && nav) {
  toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) closeSubmenus();
  });
}

document.querySelectorAll<HTMLElement>('[data-company-menu]').forEach((btn) => {
  btn.addEventListener('click', () => {
    if (!mqMobile.matches) return;

    const item = btn.closest('[data-nav-dropdown]') as HTMLElement | null;
    if (!item) return;

    const willOpen = !item.classList.contains('is-open');
    closeOtherDropdowns(item);

    if (willOpen) {
      item.classList.add('is-open');
      const sub = getSubmenu(item);
      if (sub) sub.hidden = false;
      setCompanyExpanded(item, true);
    } else {
      resetDropdownItem(item);
    }
  });
});

document.querySelectorAll<HTMLElement>('[data-nav-dropdown]').forEach((item) => {
  item.addEventListener('mouseenter', () => {
    if (!mqDesktop.matches) return;
    closeOtherDropdowns(item);
    item.classList.add('is-active');
    const sub = getSubmenu(item);
    if (sub) sub.hidden = false;
    setCompanyExpanded(item, true);
  });

  item.addEventListener('mouseleave', () => {
    if (!mqDesktop.matches) return;
    resetDropdownItem(item);
  });
});

document.addEventListener('keydown', (e: KeyboardEvent) => {
  if (e.key !== 'Escape') return;
  if (nav) nav.classList.remove('is-open');
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
  closeSubmenus();
});

mqDesktop.addEventListener('change', closeSubmenus);

closeSubmenus();

const yearEl = document.getElementById('year');
if (yearEl) yearEl.textContent = String(new Date().getFullYear());
